import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';
import camelCase from 'lodash-es/camelCase';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import { TopicWidgetProperties } from 'book-widgets/interfaces';
import { Generator } from '../topic-widgets/generator';
import css from '@holmescorp/book-widgets/css/topicpage.m.css';

const factory = create({ theme }).properties<TopicWidgetProperties>();

export const Xref = factory(({ properties, middleware: { theme } }) => {
	const { topicdata, additionalClasses = [] } = properties();
	const themeCss = theme.classes(css);
	const { children = [], attributes = { href: '#' } } = topicdata as {
		children: string[];
		attributes: { href: string };
	};
	const { href = '#' } = attributes;
	let xreftext: any = ' ';
	if (children.length == 1) {
		const kid = children[0];
		if (typeof kid === 'string') {
			const output: string = kid;
			// look for icon reference and add as a class instead
			if (output.includes('_icons_')) {
				additionalClasses.push(camelCase(output));
			} else {
				xreftext = kid;
			}
		} else {
			xreftext = w(Generator, { skipTitle: false, insection: true, topic: topicdata as any });
		}
	} else if (children.length > 1) {
		xreftext = w(Generator, { skipTitle: false, insection: true, topic: topicdata as any });
	} else {
		xreftext = '--cross-reference--';
	}

	return v('a', { classes: [themeCss.xref, ...additionalClasses], href, target: '_blank' }, [xreftext]);
});
